import { Whitelabel } from 'src/types/whitelabel';
import { axiosInstance, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

class WhitelabelRepository {
  static async getByShoppingId(host: string): Promise<Whitelabel> {
    try {
      const response = await axiosInstance.get(`${endpoints.admin.whitelabel}/${host}`);
      return response.data.whitelabel;
    } catch (error) {
      throw new Error(`Failed to fetch whitelabel: ${error.message}`);
    }
  }
}

export const whitelabelRepository = WhitelabelRepository;
